'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _BoardSharingUtil = require('./utils/sharing/BoardSharingUtil');

var _BoardSharingUtil2 = _interopRequireDefault(_BoardSharingUtil);

var _SavingFeedbackUtil = require('./utils/SavingFeedbackUtil');

var _SavingFeedbackUtil2 = _interopRequireDefault(_SavingFeedbackUtil);

var _ExportUtil = require('./utils/export/ExportUtil');

var _ExportUtil2 = _interopRequireDefault(_ExportUtil);

var _BoardTitle = require('./BoardTitle');

var _BoardTitle2 = _interopRequireDefault(_BoardTitle);

var _ElementFilterUtil = require('./utils/elementFilter/ElementFilterUtil');

var _ElementFilterUtil2 = _interopRequireDefault(_ElementFilterUtil);

require('./CurrentBoardHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var CurrentBoardHeader = function CurrentBoardHeader(_ref) {
    var currentBoardId = _ref.currentBoardId,
        isEditable = _ref.isEditable,
        elementFilter = _ref.elementFilter,
        currentBoard = _ref.currentBoard;
    return _react2.default.createElement(
        'div',
        { className: 'CurrentBoardHeader' },
        _react2.default.createElement(
            'div',
            { className: 'header-left' },
            _react2.default.createElement(_SavingFeedbackUtil2.default, null)
        ),
        _react2.default.createElement(
            'div',
            { className: 'header-center' },
            _react2.default.createElement('div', { className: 'spacer' }),
            _react2.default.createElement(_BoardTitle2.default, { currentBoardId: currentBoardId, isEditable: isEditable, currentBoard: currentBoard }),
            _react2.default.createElement(
                'div',
                { className: 'title-right' },
                _react2.default.createElement(_BoardSharingUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter }),
                elementFilter ? _react2.default.createElement(_ElementFilterUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter }) : null
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'header-right' },
            _react2.default.createElement(_ExportUtil2.default, { currentBoardId: currentBoardId, isEditable: isEditable })
        )
    );
};

// Styles
// Lib


CurrentBoardHeader.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isEditable: _propTypes2.default.bool,
    getDocumentElementSizes: _propTypes2.default.func,
    elementFilter: _propTypes2.default.object,
    currentBoard: _propTypes2.default.object
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(CurrentBoardHeader);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/CurrentBoardHeader.js
// module id = 2161
// module chunks = 0